import React, { useRef } from 'react'
import { TimePicker } from '../../ui/TempusDominus'

const TimelineTimeField = ({ name, onChange, value, timeFormat, disabled }) => {
  // Make sure we only generate a single unique id for each instance of the component
  const uniqueID = useRef(Math.random().toString(36).substring(7))

  return <TimePicker
    id={`datetimepicker-${uniqueID.current}`}
    value={value}
    onChange={value => onChange(value)}
    timeFormat={timeFormat}
    disabled={disabled}
  />
}

export default TimelineTimeField
